var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.66275 11.2136L8.82377 17.7066C10.0068 18.9533 11.9932 18.9533 13.1762 17.7066L19.3372 11.2136C21.5542 8.87708 21.5543 5.08892 19.3373 2.75244C17.1203 0.415973 13.5258 0.415974 11.3088 2.75245V2.75245C11.1409 2.92935 10.8591 2.92935 10.6912 2.75245V2.75245C8.47421 0.415974 4.87975 0.415974 2.66275 2.75245C0.44575 5.08892 0.445751 8.87708 2.66275 11.2136Z","stroke":"black","strokeWidth":"1.3"}));
}

Heart.defaultProps = {"width":"16","height":"16","viewBox":"0 0 22 20","fill":"none"};

module.exports = Heart;

Heart.default = Heart;
